var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"edit-image",on:{"click":_vm.modalEdit}},[_vm._v("Edit")]),_c('ui-delete-asset-modal',{attrs:{"asset":_vm.asset,"show":_vm.show},on:{"close":_vm.modalEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }